import { isIndivAuthFlow } from '@/utils/authTabQuery';

/** 是否 ?from=indiv 个人版入口 */
export function isIndivFromRoute(route) {
  return isIndivAuthFlow(route && route.query);
}

/** 页面根节点 :class="{ 'client-eval-page--indiv': isIndiv }" */
export const isIndivMixin = {
  computed: {
    isIndiv() {
      return isIndivFromRoute(this.$route);
    },
  },
};



// WEBPACK FOOTER //
// ./src/utils/isIndiv.js